import React from 'react'

function NavBar() {
  return (
    <div className="navbar">
      <div className="placeholder"></div>
      <div className="centered">Runway App</div>
      <div className="right">Signup / Login</div>
    </div>
  )
}

export default NavBar